import type {
  BinaryReadOptions,
  DescMessage,
  MessageShape,
} from '@bufbuild/protobuf';
import { fromBinary } from '@bufbuild/protobuf';
import { base64Decode } from '@bufbuild/protobuf/wire';
import { Code } from '@grpc-gen/google/rpc/code_pb';

import { GrpcError } from './grpc-error';

export function decodeBinaryHeader(value: string): Uint8Array;
export function decodeBinaryHeader<Desc extends DescMessage>(
  value: string,
  type: Desc,
  options?: Partial<BinaryReadOptions>,
): MessageShape<Desc>;
export function decodeBinaryHeader<Desc extends DescMessage>(
  value: string,
  desc?: Desc,
  options?: Partial<BinaryReadOptions>,
): MessageShape<Desc> | Uint8Array {
  try {
    const bytes = base64Decode(value);
    if (desc) {
      return fromBinary(desc, bytes, options);
    }
    return bytes;
  } catch (e) {
    throw GrpcError.from(e, Code.DATA_LOSS);
  }
}
